function normalizeLocationType(locationType) {
  return String(locationType || '').trim().toUpperCase()
}

function toStockNumber(value) {
  const stock = Number(value)
  return Number.isFinite(stock) ? stock : 0
}

function getProductStockSummary(stocks = []) {
  return stocks.reduce(
    (summary, stockRow) => {
      const locationType = normalizeLocationType(stockRow?.location_type)
      const availableStock = toStockNumber(stockRow?.available_stock)

      if (locationType === 'STORE') {
        return {
          ...summary,
          tokoStock: summary.tokoStock + availableStock,
        }
      }

      if (locationType === 'WAREHOUSE') {
        return {
          ...summary,
          warehouseStock: summary.warehouseStock + availableStock,
        }
      }

      return summary
    },
    { tokoStock: 0, warehouseStock: 0 }
  )
}

module.exports = {
  getProductStockSummary,
}

